import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireMain } from "C:\\Users\\nahue\\Desktop\\codebase\\wonderup\\datagrid-v2.5\\src\\main.js";
var mainExports = requireMain();
export { mainExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(mainExports);